import React, {useMemo, useRef} from "react";
import {useDetailHeroSummary} from "./DetailHeroSummaryContext";
import {useMobileFixedPageHero} from "../../hooks/useMobileFixedPageHero";
import "../layout/pageHeaderHero.css";
import "./detailListLayout.css";

function normalizeTabs(tabs = []) {
    return tabs.map((tab) => ({
        ...tab,
        name: tab.name ?? tab.title ?? "",
    }));
}

/** 상세 탭 — hero(요약 + 하단 탭) */
export function DetailTabBar({tabs, setTabs, className = "", hideTabs = false}) {
    const heroRef = useRef(null);
    useMobileFixedPageHero(heroRef);
    const normalizedTabs = useMemo(() => normalizeTabs(tabs ?? []), [tabs]);
    const heroSummary = useDetailHeroSummary();

    if (!tabs?.length || !setTabs) {
        return null;
    }

    const activeName =
        normalizedTabs.find((tab) => tab.clicked)?.name ?? normalizedTabs[0]?.name ?? "";

    const selectTab = (idx) => {
        setTabs(
            tabs.map((tab, index) => ({
                ...tab,
                clicked: index === idx,
            }))
        );
    };

    const heroTitle = heroSummary?.title ?? activeName;

    return (
        <header ref={heroRef} className={`page-header-hero detail-tab-bar-hero ${className}`.trim()}>
            <div className="detail-tab-bar-hero__main">
                <div className="detail-tab-bar-hero__title-row">
                    <h1 className="page-header-hero__title">{heroTitle}</h1>
                    {heroSummary?.actions ? (
                        <div className="detail-tab-bar-hero__summary-actions asset-detail-summary-actions">
                            {heroSummary.actions}
                        </div>
                    ) : null}
                </div>
                {heroSummary?.meta ? (
                    <p className="detail-tab-bar-hero__summary-meta">{heroSummary.meta}</p>
                ) : null}
            </div>
            {!hideTabs ? (
                <div className="detail-tab-bar-hero__foot">
                    <div className="detail-tab-bar-hero__foot-start">
                        <div className="detail-tab-bar-hero__tabs">
                            {normalizedTabs.map((tab, idx) => (
                                <button
                                    key={tab.name || idx}
                                    type="button"
                                    className={`detail-tab-bar-hero__tab${tab.clicked ? " is-active" : ""}`}
                                    onClick={() => selectTab(idx)}
                                >
                                    {tab.name}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            ) : null}
        </header>
    );
}
